
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_r79vg_103",
  "disabled": "awsui_disabled_1p2cx_r79vg_143",
  "parent": "awsui_parent_1p2cx_r79vg_146",
  "highlighted": "awsui_highlighted_1p2cx_r79vg_149",
  "content": "awsui_content_1p2cx_r79vg_153",
  "label-content": "awsui_label-content_1p2cx_r79vg_160",
  "label": "awsui_label_1p2cx_r79vg_160",
  "tag": "awsui_tag_1p2cx_r79vg_167",
  "label-tag": "awsui_label-tag_1p2cx_r79vg_168",
  "label-prefix": "awsui_label-prefix_1p2cx_r79vg_178",
  "tags": "awsui_tags_1p2cx_r79vg_191",
  "description": "awsui_description_1p2cx_r79vg_192",
  "selected": "awsui_selected_1p2cx_r79vg_203",
  "icon": "awsui_icon_1p2cx_r79vg_217",
  "icon-size-big": "awsui_icon-size-big_1p2cx_r79vg_224",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_r79vg_228",
  "trigger-variant": "awsui_trigger-variant_1p2cx_r79vg_243"
};
  